<template>
  <div class="mobileHeaderWarp">
    <div class="mobileHeader" :class="{
      mobileHeaderFex:fex||qzFex
    }" ref="mobileHeader">
      <div class="left">
        <img @click="toHome" src="../../assets/image/mobile/m_logo.png" alt="">
      </div>
      <div class="right" @click="openM">
        <img v-if="!mShow" src="../../assets/image/mobile/cd.png" alt="">
        <img v-else src="../../assets/image/mobile/m_close.png" alt="">
      </div>
    </div>
    <div class="cdListWarp" :class="{cdListWarpShow:mShow}">
<!--      <div style="height: 4rem">-->

<!--      </div>-->
      <div class="cdList">
        <div class="cdItem" v-for="(v,i) in navList" @click="navTap(v)">
          <div class="cdItemText fOb">{{ v.name }}</div>
          <img class="cdItemImg" v-if="i == currenIndex" src="../../assets/image/mobile/dsj.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props:{
    fex:{
      type:Boolean,
      default(){
        return true
      }
    }
  },
  data(){
    return {
      qzFex:false,
      mShow:false,
      navList:[
        {
          name:'Home',
          url:'Home',
          id:1,
        },
        {
          name:'About Us',
          url:'About',
          id:1,
        },
        {
          name:'Selected Portfolio',
          url:'Portfolio'
        },
        {
          name:'Team',
          url:'Team'
        },
        {
          name:'News',
          url:'News'
        },
        {
          name:'Viewpoint',
          url:'Viewpoint'
        },
        {
          name:'Contact Us',
          url:'Contact'
        }
      ]
    }
  },
  computed:{
    currenIndex(){
      return this.$store.getters.pageCurrentIndex;
    }
  },
  methods:{
    /**
     * 跳转
     * @param item
     */
    navTap(item){
      this.mShow = !this.mShow
      if(item.url == 'Home'){
        return this.toHome()
      }
      this.$router.push({name:item.url})
    },
    openM(){
      this.mShow = !this.mShow
      if(!this.fex){
        this.fex = this.mShow
      }
    },
    toHome(){
      this.$store.dispatch('setStoreByKeyData',{key:'setFGoHome',data:0})
      if(this.$route.name == 'Home'){
        this.$emit('cCurl')
      }else{
        this.$router.push({name:'Home'})
      }
    },
  }
}
</script>
<style scoped lang="scss">
.cdListWarpShow{
  top: 0 !important;
  //opacity: 1 !important;
}
.cdListWarp{
  position: fixed;
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  background: url("../../assets/image/mobile/cd_bg.png") no-repeat;
  top: -100%;
  //opacity: 0;
  left: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  flex-direction: column;
  transition: .5s;
  .cdList{
    flex: 1;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    .cdItem{
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      padding: 1.2rem 0;
      .cdItemText{
        color: #fff;
        font-size: 1.3rem;
      }
      .cdItemImg{
        margin-top: .5rem;
        width: .6rem;
      }
    }
  }
  .mobileHeaderOpT{
    position: relative !important;
    z-index: 10;
  }
}
.mobileHeaderOp{
  position: relative !important;
  z-index: -1;
  opacity: 0;
}
  .mobileHeaderWarp{
    .mobileHeader{
      //position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      box-sizing: border-box;
      display: flex;
      z-index: 1000;
      align-items: center;
      justify-content: space-between;
      padding: 0 1.3rem;
      height: 4rem;
      .left{
        width: 7rem;
        img{
          width: 100%;
        }
      }
      .right{
        width: 1.4rem;
        img{
          width: 100%;
        }
      }
    }
  }
  .mobileHeaderFex{
    position: fixed;
  }
</style>
